import React, { useEffect, useState } from 'react';

import { Skeleton } from 'antd';

type TProps = {
    isLoading: boolean;
    skeleton?: React.ReactNode;
    children?: React.ReactNode;
    delay?: number;
};

export const SkeletonWrapper = ({ isLoading, skeleton, children, delay = 0 }: TProps) => {
    const [showSkeleton, setShowSkeleton] = useState(isLoading);

    useEffect(() => {
        if (isLoading && delay > 0) {
            const timer = setTimeout(() => setShowSkeleton(true), delay);
            return () => clearTimeout(timer);
        } else { 
            setShowSkeleton(isLoading);
        }
    }, [isLoading, delay]);

    const SkeletonContent = skeleton ?? <Skeleton active />;

    return <>{showSkeleton ? SkeletonContent : children}</>;
};
